import React, { CSSProperties } from 'react'
import { Button, ButtonType } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons'
import { LinkWrapper } from '../style'

type goBackProps = {
  to?: string | object
  text?: string
  type?: ButtonType
  icon?: boolean
  isOutlined?: boolean
  isFilledOutlined?: boolean
  isDisabled?: boolean
  size?: string
  onClick?: () => void
  style?: CSSProperties
}

const GoBack = (props: goBackProps) => {
  const {
    to,
    text,
    type = 'dark',
    icon = true,
    isOutlined = true,
    isDisabled,
    isFilledOutlined = false,
    size = 'default',
    onClick = () => {},
    style,
  } = props

  if (to) {
    return (
      <LinkWrapper to={to} isDisabled={isDisabled}>
        <Button
          type={type}
          isOutlined={isOutlined}
          isFilledOutlined={isFilledOutlined}
          iconBefore={icon ? <FontAwesomeIcon icon={faChevronLeft} /> : undefined}
          isDisabled={isDisabled}
          size={size as any}
          onClick={onClick}
          style={style}
        >
          {text}
        </Button>
      </LinkWrapper>
    )
  }
  return (
    <Button
      type={type}
      isOutlined={isOutlined}
      isFilledOutlined={isFilledOutlined}
      iconBefore={icon ? <FontAwesomeIcon icon={faChevronLeft} /> : undefined}
      isDisabled={isDisabled}
      size={size as any}
      onClick={onClick}
      style={style}
    >
      {text}
    </Button>
  )
}

GoBack.defaultProps = {
  text: 'Go Back',
}

export default GoBack
